export default __webpack_public_path__ + "static/media/free-spin.debfca7d.webp";